import apiFn from 'common/services/api-service';

const api = organizationId => apiFn(`/api/cms/v1/organizations/${organizationId}/events`);

// eslint-disable-next-line import/prefer-default-export
export function list(organizationId, payload = {}, query = null) {
  const params = new URLSearchParams(query);

  if (typeof payload.offset !== 'undefined' && payload.offset > 0) {
    params.append('page', payload.offset / payload.limit);
  }

  return api(organizationId)
    .get('', {
      params,
    })
    .then(response => response?.data);
}
